
<template>
  <div :id="id" :class="className" :style="{ minHeight, width }" />
</template>
  
<script lang="ts">
import { defineComponent, onActivated, onBeforeUnmount, onDeactivated, onMounted, nextTick, watch } from 'vue'
import i18n from "@/locales/index";
const _t = i18n.global.t;
import { init, EChartsOption } from 'echarts'
import { getLanguage } from "@/utils/cookies";
export default defineComponent({
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'echartsBuildingBarComponents'
    },
    width: {
      type: String,
      default: '100%',
      required: true
    },
    minHeight: {
      type: String,
      default: '360px',
      required: true
    },
    dataX: {
      type: Object,
      default: ''
    },
    executingArr: {
      type: Object,
      default: [0]
    },
    CompletedArr: {
      type: Object,
      default: [0]
    },
    nobodyArr: {
      type: Object,
      default: [0]
    },
    abnormalArr: {
      type: Object,
      default: [0]
    },
    manualCancellationArr: {
      type: Object,
      default: [0]
    }

  },
  setup(props) {
    let language = getLanguage()
    const initChart = () => {
      const echartsBuildingBar = init(document.getElementById(props.id) as HTMLDivElement)

      echartsBuildingBar.setOption({
        title: {
          subtext: _t('home.deliverytimes')
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          bottom: '1px',
          icon: "circle"
        },
        color: ['#535665', '#F4657B', '#FBD34A', '#59CB74', '#45A0FF',],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },

        xAxis: [
          {
            type: 'category',
            data: props.dataX,
            axisLabel: {
              // interval: 0,      //坐标轴刻度标签的显示间隔(在类目轴中有效) 0:显示所有  1：隔一个显示一个 :3：隔三个显示一个...  
              formatter:function(value:string){
                // 判断是否是巡游  
                if(value === '---'){
                  return value = '巡游'
                }
                let arr:any = value.split('-')
                let arrLength = arr.length
                if(language == 'zh-cn' || language == 'ko' || language == 'ja'){
                  if(arr[arrLength-1].length > 5){
                    value = arr[arrLength-1].substr(0,5) + '...'
                  }else{
                    value = arr[arrLength-1]
                  }
                }else{
                  if(arr[arrLength-1].length > 10){
                    value = arr[arrLength-1].substr(0,10) + '...'
                  }else {
                    value = arr[arrLength-1]
                  }
                }
                return value
              }
            },
          }
        ],
        yAxis:
        {
          type: 'value',
        },
        series: [
          {
            name: _t('disinfect.Manualcancellation'),
            type: 'bar',
            barWidth: '60%',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series',
              disabled: true,
            },
            data: props.manualCancellationArr
          },
          {
            name: _t('robot.abnormal'),
            type: 'bar',
            barWidth: '60%',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series',
              disabled: true,
            },
            data: props.abnormalArr
          },
          {
            name: _t('robotState.nobodyTakesThings'),
            type: 'bar',
            barWidth: '60%',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series',
              disabled: true,
            },
            data: props.nobodyArr
          },
          {
            name: _t('robotState.Completed'),
            type: 'bar',
            barWidth: '60%',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series',
              disabled: true,
            },
            data: props.CompletedArr
          },

          {
            name: _t('robotState.executing'),
            type: 'bar',
            barWidth: '60%',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series',
              disabled: true,
            },
            data: props.executingArr
          },

        ],
        dataZoom: [
          //1.横向使用滚动条
          {
            type: 'slider',//有单独的滑动条，用户在滑动条上进行缩放或漫游。inside是直接可以是在内部拖动显示
            show: false,//是否显示 组件。如果设置为 false，不会显示，但是数据过滤的功能还存在。
            start: 0,//数据窗口范围的起始百分比0-100
            end: 100,//数据窗口范围的结束百分比0-100
            xAxisIndex: [0],// 此处表示控制第一个xAxis，设置 dataZoom-slider 组件控制的 x轴 可是已数组[0,2]表示控制第一，三个；xAxisIndex: 2 ，表示控制第二个。yAxisIndex属性同理
          },
          //2.在内部可以横向拖动
          {
            type: 'inside',// 内置于坐标系中
            start: 0,
            end: 30,
            xAxisIndex: [0]
          },
          //4.在内部可以纵向拖动
          // {
          //     type: 'inside',
          //     yAxisIndex: [0],
          //     start: 29,
          //     end: 36
          // }
        ]
      } as EChartsOption)
    }

    watch(() => props, (newVal, oldVal) => {
      setTimeout(() => {
        initChart()
      }, 500)
    }, { deep: true })

    onMounted(() => {
      setTimeout(() => {
        initChart()
      }, 500)
    })

    onBeforeUnmount(() => {

    })

    onActivated(() => {

    })

    onDeactivated(() => {

    })

    return {

    }
  }
})
</script>
  
<style scoped>
.chart {}
</style>
  